import Button from '../common/Button';

export default function Hero() {
  return (
    <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden">
      {/* Animated background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/20 via-secondary/20 to-cta/20 animate-pulse"></div>

      <div className="container-custom relative z-10">
        <div className="text-center">
          <h1 className="text-7xl md:text-9xl font-heading font-bold mb-6 animate-slide-up">
            你好，我是 Keeeer
          </h1>
          <p className="text-2xl md:text-3xl mb-8 text-gray-700 animate-slide-up" style={{ animationDelay: '0.1s' }}>
            创造者 · 开发者 · 终身学习者
          </p>
          <p className="text-lg md:text-xl mb-12 text-gray-600 max-w-2xl mx-auto animate-slide-up" style={{ animationDelay: '0.2s' }}>
            我专注于构建优雅的数字产品，分享技术见解，并持续探索前沿技术
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-slide-up" style={{ animationDelay: '0.3s' }}>
            <Button href="/projects" size="lg">
              查看我的作品
            </Button>
            <Button href="/blog" variant="outline" size="lg">
              阅读博客
            </Button>
          </div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute top-20 left-10 w-20 h-20 bg-secondary border-3 border-black shadow-neubrutal animate-float hidden md:block"></div>
      <div className="absolute bottom-20 right-10 w-16 h-16 bg-cta border-3 border-black shadow-neubrutal animate-float hidden md:block" style={{ animationDelay: '2s' }}></div>
      <div className="absolute top-1/3 right-1/4 w-12 h-12 bg-primary border-3 border-black shadow-neubrutal animate-float hidden md:block" style={{ animationDelay: '4s' }}></div>
    </section>
  );
}
